export type AppToastType = 'success' | 'error' | 'info' | 'warning';

export interface AppToastPayload {
  type: AppToastType;
  message: string;
  title?: string;
  duration?: number;
}

export const showAppToast = (payload: AppToastPayload): void => {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(
    new CustomEvent<AppToastPayload>('suite241:toast', {
      detail: payload,
    })
  );
};
